module.exports = __webpack_public_path__ + "img/Admin3-Logo.f7d649f5.svg";